function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "225",
  height: "160",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_1_1384)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M.244 0v156.791a2.93 2.93 0 002.931 2.931h218.138a2.93 2.93 0 002.931-2.931V0h-224z",
  fill: "#F3F4F6"
}), /*#__PURE__*/React.createElement("rect", {
  x: "46.244",
  y: "30.404",
  width: "132",
  height: "67.714",
  rx: "3.185",
  fill: "#6310E5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M113.623 111.059a1.592 1.592 0 01-2.758 0l-7.662-13.27h18.082l-7.662 13.27z",
  fill: "#6310E5"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "112.248",
  cy: "128",
  r: "5.6",
  fill: "#6310E5"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "112.244",
  cy: "128",
  r: "9",
  stroke: "#6310E5",
  strokeWidth: "2"
})), /*#__PURE__*/React.createElement("rect", {
  x: "1.244",
  y: "1",
  width: "222",
  height: "157.722",
  rx: "3",
  stroke: "#DDE0E4",
  strokeWidth: "2"
}), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_1_1384"
}, /*#__PURE__*/React.createElement("rect", {
  x: ".244",
  width: "224",
  height: "159.722",
  rx: "4",
  fill: "#fff"
})))));